import moment from 'moment'
import { Store } from 'redux'

import { getRefreshTokenFromStorage } from '@/lib/getRefreshTokenFromStorage'
import { IAction } from '@/redux/actions/action-helpers'
import { Actions as MyCompanyActions } from '@/redux/actions/my-company.actions'
import { Actions as MyUserRolesActions } from '@/redux/actions/my-user-roles.actions'
import { Actions as PermissionsActions } from '@/redux/actions/permissions.actions'
import { ApplicationState } from '@/redux/stores/types'
import { UserPermissionsTypes } from '@/types/permissions'
import { User } from '@/types/user'

export function isPermitted(store: Store<ApplicationState, IAction>, permission: UserPermissionsTypes) {
	const state = store.getState()
	if (!state?.userPermissions) {
		return false
	}
	const permissions = state.userPermissions
	return (permissions || []).includes(permission)
}

function loadUserPermissions(store: Store<ApplicationState, IAction>) {
	store.dispatch(PermissionsActions.getPermissions())
	store.dispatch(MyUserRolesActions.getMyUserRoles())
	store.dispatch(MyCompanyActions.getMyCompany())
}

export function canLoadUserPermissions(store: Store<ApplicationState, IAction>) {
	const state = store.getState()
	return (
		state.auth.get('internalUser') &&
		state.auth.get('termsAccepted') &&
		state.auth.get('expiresAt') &&
		(moment(state.auth.get('expiresAt')).valueOf() > moment(new Date()).valueOf() || getRefreshTokenFromStorage())
	)
}

export async function setPermissionsWhenUserLogsIn(store: Store<ApplicationState, IAction>) {
	if (canLoadUserPermissions(store)) {
		loadUserPermissions(store)
		return
	}

	const unsubscribe = store.subscribe(() => {
		if (canLoadUserPermissions(store)) {
			unsubscribe()
			loadUserPermissions(store)
		}
	})
}

export function getPermissionFromUser(user: User, permission: UserPermissionsTypes) {
	return user.user_permissions?.find((p) => p.permission === permission)
}

export function userHasPermission(user: User, permission: UserPermissionsTypes) {
	return Boolean(getPermissionFromUser(user, permission))
}

export function canEditTraveler(store: Store<ApplicationState, IAction>, userToEdit: User, currentLoggedInUser?: User) {
	return (
		isPermitted(store, 'Admin') ||
		isPermitted(store, 'ManageUsers') ||
		(!!currentLoggedInUser && userToEdit.id === currentLoggedInUser.id)
	)
}
